import React from 'react';
import { Button } from '@/components/ui/Button';
import { AlertTriangle, Clock } from 'lucide-react';

const SessionTimeoutModal = ({ 
  isOpen, 
  timeRemaining, 
  onExtendSession, 
  onClose 
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        <div className="p-6">
          <div className="flex items-center mb-4">
            <div className="flex-shrink-0">
              <AlertTriangle className="h-6 w-6 text-yellow-600" />
            </div>
            <div className="ml-3">
              <h3 className="text-lg font-medium text-gray-900">
                Session Timeout Warning
              </h3>
            </div>
          </div>
          
          <div className="mb-4">
            <p className="text-sm text-gray-600 mb-3">
              Your session will expire in{' '}
              <span className="font-semibold text-yellow-600">
                {timeRemaining}
              </span>{' '}
              due to inactivity.
            </p>
            
            <div className="bg-yellow-50 border border-yellow-200 rounded-md p-3">
              <div className="flex items-center">
                <Clock className="h-4 w-4 text-yellow-600 mr-2" />
                <p className="text-sm text-yellow-800">
                  Click &quot;Extend Session&quot; to continue working, or you&apos;ll be automatically signed out.
                </p>
              </div>
            </div>
          </div>
          
          <div className="flex space-x-3">
            <Button
              onClick={onExtendSession}
              className="flex-1"
            >
              Extend Session
            </Button>
            <Button
              onClick={onClose}
              variant="outline"
              className="flex-1"
            >
              Sign Out Now
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SessionTimeoutModal;
